import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const questionnaireGuard = createFeatureGuard(Feature.Questionnaire);